/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_location_control__tooltip__text = /** @type {(inputs: {}) => string} */ () => {
	return `Ändern Sie Ihre Browser-Einstellungen, um den Zugriff auf Ihren Standort zuzulassen.`
};

const en_location_control__tooltip__text = /** @type {(inputs: {}) => string} */ () => {
	return `Modify your browser settings to authorize access to your location.`
};

const es_location_control__tooltip__text = /** @type {(inputs: {}) => string} */ () => {
	return `Modifica los ajustes de tu navegador para autorizar el acceso a tu ubicación.`
};

const fr_location_control__tooltip__text = /** @type {(inputs: {}) => string} */ () => {
	return `Modifiez les paramètres de votre navigateur pour autoriser l'accès à votre position.`
};

const it_location_control__tooltip__text = /** @type {(inputs: {}) => string} */ () => {
	return `Modifica le impostazioni del browser per autorizzare l’accesso alla posizione.`
};

const nl_location_control__tooltip__text = /** @type {(inputs: {}) => string} */ () => {
	return `Uw browserinstellingen aanpassen om toegang tot uw locatie toe te staan.`
};

const pt_location_control__tooltip__text = /** @type {(inputs: {}) => string} */ () => {
	return `Altere as definições do seu navegador para autorizar o acesso à sua posição.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.location_control__tooltip__text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("location_control__tooltip__text", locale)
	if (locale === "de") return de_location_control__tooltip__text(inputs)
	if (locale === "en") return en_location_control__tooltip__text(inputs)
	if (locale === "es") return es_location_control__tooltip__text(inputs)
	if (locale === "fr") return fr_location_control__tooltip__text(inputs)
	if (locale === "it") return it_location_control__tooltip__text(inputs)
	if (locale === "nl") return nl_location_control__tooltip__text(inputs)
	return pt_location_control__tooltip__text(inputs)
};